import type { Transition } from "@uirouter/core";
import categoryService from "app/common/services/categoryService";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { swSettings } from "app/common/services/swSettings";
import { periodOverPeriodService } from "app/services/PeriodOverPeriodService";

export const onEnterIndustryResearchPageHof =
    (
        defaultConfigID: string,
        industryWithSegmentConfigId: string,
        resolveConfigID = CategoryServiceUtils.resolveConfigID,
    ) =>
    (transition: Transition) => {
        const toParams = transition.params();
        const { duration, comparedDuration, category, country } = toParams;
        const toState = transition.to();
        const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
        const toConfigID = resolveConfigID(defaultConfigID, categoryObject, industryWithSegmentConfigId);
        const toComponent = swSettings.components[toConfigID];
        const allowedDuration = swSettings.allowedDuration(duration, toConfigID);
        const isPeriodOverPeriodAllowed = comparedDuration
            ? periodOverPeriodService._periodOverPeriodEnabled(duration, comparedDuration, [], toConfigID)
            : true;
        if (!allowedDuration || !isPeriodOverPeriodAllowed) {
            return transition.router.stateService.target(toState.name, {
                ...toParams,
                comparedDuration: undefined,
                duration: toComponent.defaultParams.duration,
            });
        }
        const allowedCountry = swSettings.allowedCountry(country, toConfigID);
        if (!allowedCountry) {
            return transition.router.stateService.target(toState.name, {
                ...toParams,
                country: toComponent.defaultParams.country,
            });
        }
    };
